import { useContext } from "react";

import { TextInput } from "@/DesignSystem";
import { EncounterDateContext } from "@/Flowsheets/Contexts/EncounterDateContext";
import { TextReviewedCareElement } from "@/Flowsheets/Models/CareElements/TextReviewedCareElement";
import { CareElementDateReviewedRow } from "./CareElementDateReviewedRow";

interface ICareElementTextDateReviewedProps {
    isEditable: boolean;
    label: string;
    textLabel?: string;
    side?: "row" | "column";
    element: TextReviewedCareElement;
    onChange: (element: TextReviewedCareElement) => void;
}

export function CareElementDateReviewedTextControl(props: Readonly<ICareElementTextDateReviewedProps>): JSX.Element {
    const { element, onChange, isEditable, side = "row", label, textLabel } = props;

    const { encounterDateTimeWithPrecision } = useContext(EncounterDateContext);

    return (
        <CareElementDateReviewedRow
            element={element}
            onChange={onChange}
            isEditable={isEditable}
            label={label}
            side={side}
            setFalseAsValid
            isDatePickerVisible={element.Value?.trim().length > 0}
        >
            <TextInput
                id={`care-element-text-${element?.Name}`}
                label={textLabel}
                value={element.Value ?? ""}
                disabled={!isEditable}
                labelPosition="top"
                onChange={event => {
                    const text = event.target.value;
                    const isValid = !IsNullOrWhiteSpace(text);
                    const shouldAutoFillDate = isValid && !element.DateReviewedWithPrecision?.value;

                    let dateToUse = null;

                    if (isValid) {
                        dateToUse = shouldAutoFillDate
                            ? encounterDateTimeWithPrecision
                            : element.DateReviewedWithPrecision;
                    }

                    onChange(new TextReviewedCareElement({ ...element, Value: text, DateReviewedWithPrecision: dateToUse }));
                }}
                maxLength={200}
            />
        </CareElementDateReviewedRow>
    );
}
